import React from "react";
import { Outlet } from "react-router-dom";
import styles from "../../styles/Layout.module.css";
import Header from "./Partials/Header";
import { Box, Link, Typography } from "@mui/material";
import Footer from "./Partials/Footer";


const SignUpLayOut = () => {


    return (
        <div className={styles.layout}>
            <Header />
            <div className={styles.main} style={{marginTop:'67px'}}>
                <div className={styles.content}>
                    <Outlet />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default SignUpLayOut;
